<template>
  <div id="container">
    <div class="product-status">
    <div class="bold">
      <!-- <span class="new-solid number-yet">19</span>
      <span class="new-solid number-wait">2</span>
      <span class="new-solid number-yetCreate">3</span> -->
      </div>
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane
          :label="item.title"
          :name="item.name"
          v-for="(item,index) in stockListTabBars"
          class="tab-text"
          :key="index"
        >
          <el-form class="search-style" :model="queryParams">
            <el-row :gutter="20">
              <el-col :span="4" v-if="activeName ==='pendingTask'">
                <el-form-item>
                  <el-select
                    v-model="queryParams.column"
                    @change="onSelect(queryParams.column)"
                    placeholder="请选择"
                  >
                    <el-option
                      v-for="(item,index) in warehouse1"
                      :key="index"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="4" v-if="activeName ==='myPending'">
                <el-form-item>
                  <el-select
                    v-model="queryParams.column"
                    @change="onSelect(queryParams.column)"
                    placeholder="请选择"
                  >
                    <el-option
                      v-for="(item,index) in warehouse2"
                      :key="index"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="4" v-if="activeName ==='myProcessed'">
                <el-form-item>
                  <el-select
                    v-model="queryParams.column"
                    @change="onSelect(queryParams.column)"
                    placeholder="请选择"
                  >
                    <el-option
                      v-for="(item,index) in warehouse3"
                      :key="index"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="4" v-if="queryParams.column === 'outstockType'">
                <el-form-item>
                  <el-select v-model="params.value">
                    <el-option label="销售发货" value='销售出库'></el-option>
                    <el-option label="维修出库" value="维修出库"></el-option>
                    <el-option label="退货出库" value="退货出库"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="4" v-if="queryParams.column === 'lackState'">
                <el-form-item>
                  <el-select v-model="params.value">
                    <el-option label="报缺审核中" value='报缺审核中'></el-option>
                    <el-option label="报缺审核通过" value="报缺审核通过"></el-option>
                    <el-option label="报缺审核未通过" value="报缺审核未通过"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="4" v-if="queryParams.column === 'state'">
                <el-form-item>
                  <el-select v-model="params.value">
                    <el-option label="请求发货" :value='1'></el-option>
                    <el-option label="发货审核" :value="2"></el-option>
                    <el-option label="设置出库单" :value="3"></el-option>
                    <el-option label="待发货" :value="4"></el-option>
                    <el-option label="已发货" :value="5"></el-option>
                    <el-option label="已下单，快递未揽件" :value="6"></el-option>
                    <el-option label="已作废" :value="7"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <!--  物流订单状态- -->
              <el-col :span="6">
                <el-form-item>
                  <el-input v-model="params.value" placeholder="请输入关键词"
                  v-if='queryParams.column !== "createDate" && queryParams.column !== "deliverDate" && queryParams.column !== "processDate" && queryParams.column !=="updateDate" && queryParams.column !== "pickDate" && queryParams.column !== "arrivalTime" && queryParams.column !== "outstockType"  && queryParams.column !== "logisticState" && queryParams.column !== "state" && queryParams.column !== "lackState"'
                  ></el-input>
                  <el-date-picker
                   v-show='queryParams.column === "createDate" || queryParams.column === "deliverDate" || queryParams.column === "processDate" || queryParams.column === "updateDate" || queryParams.column === "pickDate" || queryParams.column === "arrivalTime"'
                    v-model="time"
                     style="width:100%;"
                    type="daterange"
                    range-separator="-"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd HH:mm"
                    :default-time="['00:00:00','23:59:59']"
                  ></el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="4">
                <el-form-item>
                  <el-button type="primary" @click="onSearch">搜索</el-button>
                  <el-button  @click="resetProduct">重置</el-button>
                </el-form-item>
              </el-col>
             <el-col :span="10" style='text-align:right'>
                  <el-form-item  v-show="activeName === 'pendingTask'">
                    <!-- <el-button  v-show="activeName !== 'myPending'">条码识别</el-button> -->
                    <el-button  @click="onBatch"  type="primary">批量认领</el-button>
                    <el-checkbox style='padding-left:20px;' v-model="checked" >每60秒刷新当前页面</el-checkbox>
                  </el-form-item>
                </el-col>
            </el-row>
          </el-form>
          <div class="box-table" :style="{height:tableHeight+'px'}">
            <el-table
              type="reset"
              border
              ref="tableRef"
              tooltip-effect="dark"
              :data="list"
              :header-cell-style="tableHeader"
              v-loading="loadingTable"
              element-loading-text="拼命加载中请稍后..."
              :max-height="tableHeight"
              element-loading-spinner="el-icon-loading"
              @selection-change="handleSelectionChange"
            >
             <el-table-column fixed type="selection" width="55"  :selectable="selectableFun" v-if="processState === 1"></el-table-column>
              <el-table-column v-if="activeName === 'myProcessed'" label="发货编号" width="150px" :key="'1'">
                <template slot-scope="scope">
                  <div
                    class="approval line-limit-length"
                    @click="toDetail(scope.row)"
                  >{{scope.row.deliverNumber}}</div>
                </template>
              </el-table-column>
              <el-table-column v-if="activeName === 'pendingTask'" prop='deliverNumber' label="发货编号" width="150px" :key="'2'">
              </el-table-column>
              <el-table-column v-if="activeName === 'myPending'" label="发货编号" width="150px" :key="'3'">
                <template slot-scope="scope">
                  <div>{{scope.row.deliverNumber || '--'}}</div>
                </template>
              </el-table-column>
              <el-table-column label="所在仓库" width="140px" v-show="activeName !== 'myProcessed'" prop="storageName" :key="'4'"
              ></el-table-column>
              <el-table-column label="发货类型" prop="outstockType" :key="'5'"></el-table-column>
              <el-table-column label="发货方式" prop="deliverMode" :key="'6'"></el-table-column>
              <el-table-column label="发起人" prop="createUser" :key="'7'"></el-table-column>
              <el-table-column label="请求发货时间" width="150px" :key="'8'">
                <template slot-scope="scope">
                  <div>{{scope.row.createDate|dateFilterL}}</div>
                </template>
              </el-table-column>
              <el-table-column label="认领人"  v-if="activeName === 'pendingTask'" :key="'10'">
                <template slot-scope="scope">
                  <div>{{scope.row.staffCnName || '--'}}</div>
                </template>
              </el-table-column>
              <el-table-column label="认领时间" width="150px" v-if="activeName !== 'myProcessed'" :key="'11'">
                <template slot-scope="scope">
                  <div>{{scope.row.processDate|dateFilterL}}</div>
                </template>
              </el-table-column>
              <el-table-column label="发货说明" v-if="activeName === 'myProcessed'" width="150px" prop='mark' :key="'12'"></el-table-column>
              <el-table-column label="预计到达日期" v-if="activeName === 'myProcessed'" width="150px" :key="'13'">
                <template slot-scope="scope">
                  <div>{{scope.row.arrivalTime|dateFilterL}}</div>
                </template>
              </el-table-column>
              <el-table-column label="处理时间" v-if="activeName === 'myProcessed'" width="150px" :key="'14'">
                <template slot-scope="scope">
                  <div>{{scope.row.updateDate|dateFilterL}}</div>
                </template>
              </el-table-column>
              <el-table-column label="报缺状态" v-if="activeName !== 'pendingTask'"  :key="'15'">
                <template slot-scope="scope">
                  <div>{{scope.row.lackState || '--'}}</div>
                </template>
              </el-table-column>
              <el-table-column label="发货状态" v-if="activeName !== 'pendingTask'" :key="'16'">
                <template slot-scope="scope">
                  <span>{{scope.row.state===1 ?'请求发货': scope.row.state===2 ?'发货审核':scope.row.state===3 ?'设置出库单': scope.row.state===4 ?'待发货':scope.row.state===5 ?'已发货':scope.row.state===6 ?'已下单，快递未揽件':'已作废'}}</span>
                </template>
              </el-table-column>
              <el-table-column label="发货时间" v-if="activeName === 'myProcessed'" width="150px" :key="'17'">
                <template slot-scope="scope">
                  <div>{{scope.row.deliverDate|dateFilterL}}</div>
                </template>
              </el-table-column>
              <el-table-column
              :key="'18'"
                label="操作"
                width="200px"
                v-if="activeName !== 'myProcessed'"
                fixed="right"
              >
                <template slot-scope="scope">
                <el-button
                    type="text"
                    :disabled="disabled"
                    @click="claimantDetail(scope.row)"
                    v-if="scope.row.staffCnName === null"
                  >认领</el-button>
                  <el-button
                    type="text"
                    :disabled="disabled"
                    @click="handleDetail(scope.row)"
                    v-if="scope.row.staffCnName !== localUser && scope.row.staffCnName !== null && scope.row.stockPower === 2"
                  >提取</el-button>
                  <el-button
                    type="text"
                    :disabled="disabled"
                    @click="toDetail(scope.row)"
                    v-if="scope.row.staffCnName === localUser"
                  >处理</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
            <div class="pagination"  style="padding-top:20px">
              <pagination
                :total="total"
                :currentPage="currentPage"
                :pageSize="pageSize"
                @handleCurrentChange="handleCurrentChange"
                @handleSizeChange="handleSizeChange"
              ></pagination>
            </div>
        </el-tab-pane>
      </el-tabs>
        <open-or-close
      @onUpdataState="onUpdataState"
      content="确认是否批量认领？"
      title="提示"
      ref="openOrCloseRefs"
    ></open-or-close>
    </div>
  </div>
</template>
<script>
import { stockListTabBars, warehouse3, warehouse2, warehouse1 } from './util/data'
import pagination from '@/components/pagination'
import { expressionList } from '@/components/utils/data'
import { queryPageOutStockp, updateStorageProcessState, updateState, updateStateExtractByStorage } from '@/api/storage/storage'
import { getAuth } from '@/util/auth'
import OpenOrClose from '@/components/OpenOrClose/index'

export default {
  components: {
    pagination,
    'open-or-close': OpenOrClose

  },
  data () {
    return {
      tableHeight: window.innerHeight - 400,
      disabled: false,
      checked: false,
      timer: [],
      activeName: 'pendingTask',
      stockListTabBars: stockListTabBars, // tabs状态
      warehouse3: [],
      warehouse2: [],
      warehouse1: [],
      expressionList: [],
      queryParams: {
        column: ''
      },
      params: {
        endValue: '',
        value: ''
      },
      list: [], // 列表数据
      loadingTable: false, // 列表loading
      processState: 1,
      pageSize: 30, // 页数
      currentPage: 1, // 页码
      total: 0, // 列表总数
      time: [],
      showName: '',
      tempList: [],
      checkList: []

    }
  },
  mounted () {
    this.getList()
    this.expressionList = expressionList
    this.warehouse3 = warehouse3
    this.warehouse2 = warehouse2
    this.warehouse1 = warehouse1
    this.showName = localStorage.getItem('username')
    this.getUser()
  },
  watch: { // 监听父级tabs状态请求列表接口
    activeName () {
      this.tabActiveName = this.activeName
      this.queryParams = {}
      this.params = {}
    },
    checked: {
      handler (newVal) {
        if (newVal === true) {
          this.timer = setInterval(() => {
            this.getList()
          }, 60000)
        } else {
          clearInterval(this.timer)
        }
      }
    }
  },
  methods: {
    // 登录人
    getUser () {
      this.localUser = JSON.parse(getAuth()).usercnname
    },
    selectableFun(row) {
      if (row.staffCnName === null) {
        return true
      }
    },
    handleSelectionChange(val) {
      this.checkList = val
    },
    onBatch() {
      if (this.checkList.length < 1) {
        this.$message.error('请选择一条或者多条')
      } else {
        this.$refs.openOrCloseRefs.onInitial()
      }
    },
    onUpdataState() {
      const arr = []
      this.checkList.forEach(ele => {
        arr.push(ele.soId)
      })
      updateState(1, arr)
        .then(res => {
          if (res.data.code === 200) {
            this.$message.success('已认领!')
            this.getList()
          } else {
            this.$message.error(res.data.msg)
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    // 认领
    claimantDetail (row) {
      const arr = []
      const arr1 = [row]
      arr1.forEach(ele => {
        arr.push(ele.soId)
      })
      updateState(1, arr)
        .then(res => {
          if (res.data.code === 200) {
            this.$message.success('已认领!')
            this.getList()
          } else {
            this.$message.error(res.data.msg)
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    // 设置头部背景色
    tableHeader ({ rowIndex }) {
      return this.$tableHeader(rowIndex)
    },
    handleClick (tab) {
      this.checked = false
      this.activeName = tab.name
      this.resetProduct()
    },
    // 表格
    getList () {
      this.loadingTable = true
      if (this.activeName === 'pendingTask') {
        this.processState = 1
      } else if (this.activeName === 'myPending') {
        this.processState = 2
      } else if (this.activeName === 'myProcessed') {
        this.processState = 3
      }
      const params = {
        criteriaVoList: [...this.tempList],
        queryPageName: ''
      }
      queryPageOutStockp(this.processState, 3, this.currentPage, this.pageSize, params).then(res => {
        if (res.data.code === 200) {
          this.list = res.data.obj.records
          this.total = res.data.obj.total
          this.loadingTable = false
        } else {
          this.$message.error(res.data.msg)
        }
      }).catch(err => {
        console.log(err)
      })
    },
    // 搜索select change
    onSelect (val) {
      this.queryParams = {
        column: val
      }
      this.params = {
        expression: 'eq'
      }
      this.time = []
    },
    // 搜索
    onSearch () {
      if (this.time && this.time.length > 1) {
        this.params.value = this.time[0]
        this.params.endValue = this.time[1]
      }
      if (
        this.params.value === '' ||
        this.params.value === undefined ||
        this.queryParams.column === undefined
      ) {
        this.$message.error('搜索条件不能为空')
      } else {
        this.pageSize = 30
        this.currentPage = 1
        this.tempList = this.$queryParams(this.queryParams, this.params)
        this.getList()
      }
    },
    // 重置
    resetProduct () {
      this.tempList = []
      this.pageSize = 30
      this.currentPage = 1
      this.params.value = ''
      this.params.expression = ''
      this.queryParams = {
        warehouse3: '',
        warehouse2: '',
        warehouse1: ''
      }
      this.getList()
    },

    // 提取
    handleDetail (row) {
      updateStateExtractByStorage(row.soId, 3)
        .then(res => {
          if (res.data.code === 200) {
            this.getList()
            this.$message.success(res.data.msg)
          } else {
            this.$message.error(res.data.msg)
          }
        })
        .catch(err => {
          console.log(err)
        })
    },

    // 提取
    onExtract (row) {
      let params = {}
      params = row
      updateStorageProcessState(3, params).then(res => {
        if (res.data.code === 200) {
          this.getList()
        } else {
          this.$message.error(res.data.msg)
        }
      }).catch(err => {
        console.log(err)
      })
    },
    // --------跳转到详情----------
    toDetail (row) {
      if (row.staffCnName !== this.showName) {
        this.disabled = true
      }
      // socId 出库单id  state 发货状态 1请求发货2发货审核3设置出库单4待发货5已发货6已下单，快递未揽件 7已作废
      // deliverMode 发货方式: 1物流/快递 2自提 3仓库
      // 跳详情页
      // const deliverMode = row.deliverMode === '物流/快递' ? 1 : row.deliverMode === '自提 ' ? 2 : 3
      this.$router.push({ path: 'wearhouseDetial', query: { id: row.soId, state: row.state, deliverMode: 3, outstockType: row.outstockType } })
    },
    // 页数
    handleSizeChange (val) {
      this.pageSize = val
      this.currentPage = 1
      this.getList()
    },
    // 页码
    handleCurrentChange (val) {
      this.currentPage = val
      this.getList()
    }
  }
}

</script>
<style lang="scss" scoped>
.number-yet,
.number-wait,
.number-yetCreate {
  bottom: 14px;
  left: 122px;
}
.number-wait {
  left: 245px;
}
.number-yetCreate {
  left: 365px;
}
</style>
